// Per-page renderer for "data-quality" — extracted from reportBuilder.js.
// Signature: async (api, doc, ctx) => { y, aiInsights, aiRecommendations }
import autoTable from 'jspdf-autotable';
import { NAVY, fetchPageAI } from '../utils';
import { drawVerticalBarChart } from '../charts';

export async function renderDataQuality(api, doc, ctx) {
  const { qs, filterDesc, cs, pw, page, filters } = ctx;
  let y = ctx.y;
  let aiInsights = [];
  let aiRecommendations = [];

  const res = await api.get('/analytics/data-quality');
  const d = res.data;

  if (d.has_data) {
    const sectionLines = (d.sections || []).map(s => `- ${s.name}: ${s.completeness_pct}% (${s.status})`).join('\n');
    const dataContext = `Overall Data Quality Score: ${d.overall_score}%\nTotal Records: ${d.total_records}\nSample Size: ${d.sample_size}\n\nSection Scores:\n${sectionLines}`;

    try {
      const aiRes = await fetchPageAI(api, { page, dataContext, filterDesc, filters });
      aiInsights = aiRes.insights;
      aiRecommendations = aiRes.recommendations;
    } catch {}

    autoTable(doc, {
      startY: y,
      head: [['Overall Score', 'Total Records', 'Sample Size']],
      body: [[`${d.overall_score}%`, String(d.total_records), String(d.sample_size)]],
      styles: { fontSize: 10, halign: 'center' },
      headStyles: { fillColor: NAVY },
      margin: { left: 14, right: 14 },
    });
    y = doc.lastAutoTable.finalY + 8;

    if (d.sections?.length > 0) {
      const chartData = d.sections.map(s => ({ label: s.name, value: s.completeness_pct }));
      y = drawVerticalBarChart(doc, 14, y, pw - 28, 75, chartData, { title: 'Data Completeness by Section' });
    }

    if (d.sections?.length > 0) {
      if (y > 200) { doc.addPage(); y = 15; }
      autoTable(doc, {
        startY: y,
        head: [['Section', 'Completeness', 'Weight', 'Status', 'Unlocks']],
        body: d.sections.map(s => [
          s.name,
          `${s.completeness_pct}%`,
          String(s.weight),
          s.status?.toUpperCase(),
          (s.unlocks || '').substring(0, 50),
        ]),
        styles: { fontSize: 6.5 },
        headStyles: { fillColor: NAVY },
        margin: { left: 14, right: 14 },
        columnStyles: { 3: { fontStyle: 'bold' } },
      });
      y = doc.lastAutoTable.finalY + 8;
    }

    if (d.recommendations?.length > 0) {
      if (y > 220) { doc.addPage(); y = 15; }
      autoTable(doc, {
        startY: y,
        head: [['Priority Improvement', 'Current', 'Impact', 'Missing Fields']],
        body: d.recommendations.map(r => [
          r.section,
          `${r.current_pct}%`,
          String(r.impact),
          (r.missing_fields || []).join(', ').substring(0, 50),
        ]),
        styles: { fontSize: 7 },
        headStyles: { fillColor: NAVY },
        margin: { left: 14, right: 14 },
      });
      y = doc.lastAutoTable.finalY + 8;
    }
  } else {
    doc.setFontSize(9);
    doc.setTextColor(100);
    doc.text('No data uploaded yet. Upload transaction data to see quality metrics.', 14, y);
    y += 10;
  }

  return { y, aiInsights, aiRecommendations };
}
